import styled from "styled-components";

type Props = {
  backgroundColor: string;
};

const AreaNav = ({ backgroundColor }: Props) => {
  return <DivAreaNav $backgroundColor={backgroundColor}></DivAreaNav>;
};

const DivAreaNav = styled.div<{ $backgroundColor?: string }>`
  width: 2rem;
  height: 2rem;
  background-color: ${(props) => props.$backgroundColor ?? "white"};
  cursor: pointer;
  &&&:hover {
    opacity: 0.75;
  }
`;

export default AreaNav;
